// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__2y6I2","imageUploader":"EGiftCard_imageUploader__Zaj08"};